import { createAction, props } from '@ngrx/store';
import { Error } from '@rpe/registro-personas-empresas-lib';
import { SitioProcesamiento } from './sitios-procesamiento.model';

// LOAD
export const entitySitiosProcesamientoLoadRequest = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Load Request'
);

export const entitySitiosProcesamientoLoadFailure = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Load Failure',
  props<{ error: Error }>()
);

export const entitySitiosProcesamientoLoadSuccess = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Load Success',
  props<{ items: SitioProcesamiento[] }>()
);

// ADD
export const entitySitiosProcesamientoAddRequest = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Add Request',
  props<{ item: SitioProcesamiento[] }>()
);

export const entitySitiosProcesamientoAddFailure = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Add Failure',
  props<{ error: Error }>()
);

export const entitySitiosProcesamientoAddSuccess = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Add Success',
  props<{ item: SitioProcesamiento[] }>()
);

// DELETE
export const entitySitiosProcesamientoDeleteSuccess = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Delete Success',
  props<{ item: SitioProcesamiento }>()
);

export const entitySitiosProcesamientoDeleteRequest = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Delete Request',
  props<{ item: SitioProcesamiento }>()
);

export const entitySitiosProcesamientoDeleteFailure = createAction(
  '[ENTITYSITIOSPROCESAMIENTO] Delete Failure',
  props<{ error: Error }>()
);
